module.exports = __webpack_public_path__ + "img/Bowie_House_Logo.c6d903ea.png";